/**
 * REFACTORED: novicell_material-feature.js
 * Wrapped logic in a global function to allow re-initialization by Connected Products
 */

// Change const to let so we can update them when content changes
let materialDivs = document.querySelectorAll('.material-section > div');
let optionImages = document.querySelectorAll('img[data-option-value-name]');

// Define the initialization function globally
window.initMaterialFeature = function() {
  // 1. Re-query the DOM elements (crucial after content replacement)
  materialDivs = document.querySelectorAll('.material-section > div');
  optionImages = document.querySelectorAll('img[data-option-value-name]');

  // 2. Handle Mobile Grid Logic
  // We manually trigger this logic since DOMContentLoaded has already passed
  if (window.matchMedia('(max-width: 750px)').matches) {
    handleMaterialGrid();
  }

  // 3. Setup Initial State (First material selection)
  if (materialDivs.length > 0) {
    const firstMaterial = materialDivs[0];
    const firstMaterialName = firstMaterial.querySelector('h3').textContent.trim();
    const optionGroups = firstMaterial.querySelectorAll('.material-switch-flex');
    let i = 1;
    optionGroups.forEach((group) => {
      const optionLabel = group.querySelector('p');
      if (optionLabel) {
        // Only run initialization logic if not already selected (prevents double-setting on re-init)
        const span = group.querySelector('.seleceted-option-value');
        const firstImg = group.querySelector('img');
        
        // Reset/Ensure defaults
        if (i == 1) {
          if (span && !span.textContent.trim()) span.textContent = ' ' + firstMaterialName;
          if (firstImg && !firstImg.classList.contains('selected')) firstImg.classList.add('selected');
          if (firstImg) firstImg.setAttribute('aria-pressed', 'true');
        }
        i++;
      }
    });
    // Ensure the first div is shown
    showMaterialDiv(materialDivs[0]);
  }

  // 4. Attach Event Listeners to Images
  if (optionImages.length > 0) {
    optionImages.forEach((img) => {
      // Remove old listeners using the exact stored references, if any
      if (img._handleOptionImageClick) {
        img.removeEventListener('click', img._handleOptionImageClick);
      }
      if (img._handleOptionImageKeydown) {
        img.removeEventListener('keydown', img._handleOptionImageKeydown);
      }
      // Store the current handler references on the element and add them
      img._handleOptionImageClick = handleOptionImageClick;
      img.addEventListener('click', img._handleOptionImageClick);

      // <img role="button"> isn't natively activated by Enter/Space — wire it
      // up so keyboard users can select a swatch after tabbing to it.
      img._handleOptionImageKeydown = function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          img.click();
        }
      };
      img.addEventListener('keydown', img._handleOptionImageKeydown);
    });
  }
};

// Standard Page Load Initialization
document.addEventListener('DOMContentLoaded', () => {
  window.initMaterialFeature();

  // Resize listener stays global (only needs to be added once)
  window.matchMedia('(max-width: 750px)').addEventListener('change', (e) => {
    if (e.matches) {
      handleMaterialGrid();
    } else {
      document.querySelectorAll('.material-show-more').forEach((button) => {
        button.remove();
      });
      document.querySelectorAll('.material-option-image').forEach((img) => {
        img.classList.remove('d-none');
      });
    }
  });
});

// --- Helper Functions (Keep these as they were) ---

function handleMaterialGrid() {
  const allMaterials = document.querySelectorAll('.material-options-flex');
  // ... (rest of function logic) ...
  // Note: Ensure this function re-queries locally if it relies on specific elements
  // The original implementation looks safe as it queries .material-options-flex inside
  
  // PASTE YOUR ORIGINAL handleMaterialGrid IMPLEMENTATION HERE
  // Shortened for brevity in this answer, ensure the full original code is present.
  const selected = document.querySelector('.material-option-image.selected');
  const container = selected?.parentElement;
  const materials = container?.querySelectorAll('.material-option-image');
  if (!materials) return; // Added safety check

  let limitMaterialsOnMobile = 5;
  if (materials.length == 6) {
    limitMaterialsOnMobile = 6;
  }

  allMaterials.forEach((material) => {
    const currentMaterial = Array.from(material.children);
    currentMaterial.forEach((img, index) => {
      if (index >= limitMaterialsOnMobile) {
        img.classList.add('d-none');

        if (index == currentMaterial.length - 1) {
          // Check if button already exists before adding
          if(!material.querySelector('.material-show-more')) {
             const showMoreButton = document.createElement('button');
             showMoreButton.classList.add('material-show-more');
             showMoreButton.textContent = `+ ${materials.length - limitMaterialsOnMobile}`;
             showMoreButton.addEventListener('click', (e) => {
               e.preventDefault();
               document.querySelectorAll('.material-option-image').forEach((img) => {
                 img.classList.remove('d-none');
               });
               document.querySelectorAll('.material-show-more').forEach((button) => {
                 button.remove();
               });
               showMoreButton.remove();
             });
             material.appendChild(showMoreButton);
          }
        }
      }
    });
  });
}

function clearAllImageSelections() {
  const allImages = document.querySelectorAll('.material-switch-part img');
  allImages.forEach((img) => {
    img.classList.remove('selected');
    if (img.getAttribute('role') === 'button') {
      img.setAttribute('aria-pressed', 'false');
    }
  });
}

function hideAllMaterialDivs() {
  materialDivs.forEach((div) => {
    div.classList.add('tw-hidden');
    div.classList.remove('tw-grid');
  });
}

function showMaterialDiv(div) {
  div.classList.remove('tw-hidden');
  div.classList.add('tw-grid');
}

function updateGroupSelection(group, optionName, optionValue) {
  const groupName = group.querySelector('p').textContent.split(':')[0].trim();
  if (groupName === optionName) {
    const span = group.querySelector('.seleceted-option-value');
    if (span) {
      span.textContent = ' ' + optionValue;
    }

    const newGroupImages = group.querySelectorAll('img');
    newGroupImages.forEach((newImg) => {
      newImg.classList.remove('selected');
      const matches = newImg.getAttribute('data-option-value-name') === optionValue;
      if (matches) {
        newImg.classList.add('selected');
      }
      if (newImg.getAttribute('role') === 'button') {
        newImg.setAttribute('aria-pressed', matches ? 'true' : 'false');
      }
    });
  }
}

function findAndShowMatchingMaterial(optionValue, optionName) {
  let matchFound = false;

  materialDivs.forEach((div) => {
    const titleElement = div.querySelector('h3');
    if (titleElement && titleElement.textContent.trim() === optionValue) {
      showMaterialDiv(div);
      matchFound = true;

      const allGroups = div.querySelectorAll('.material-switch-flex');
      allGroups.forEach((group) => {
        updateGroupSelection(group, optionName, optionValue);
      });
    }
  });

  return matchFound;
}

function showDefaultMaterial(optionValue) {
  console.log('No material found with name: ' + optionValue);
  if (materialDivs[0]) {
    showMaterialDiv(materialDivs[0]);
  }
}

function handleOptionImageClick() {
  const optionValue = this.getAttribute('data-option-value-name');
  const clickedGroup = this.closest('.material-switch-flex');
  if (!clickedGroup) return;

  const optionName = clickedGroup.querySelector('p').textContent.split(':')[0].trim();

  clearAllImageSelections();
  this.classList.add('selected');
  if (this.getAttribute('role') === 'button') {
    this.setAttribute('aria-pressed', 'true');
  }
  hideAllMaterialDivs();

  const matchFound = findAndShowMatchingMaterial(optionValue, optionName);

  if (!matchFound) {
    showDefaultMaterial(optionValue);
  }
}